import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_apex_web_bf_one_liner_summary_v3_ddot",
    stages: {
        main: 1,
        cancellation_incl: 2,
        cancellation_fee: 3,
        flexibility_incl: 4,
        flexibility_fee: 5,
        baggage: 6,
        multi_baggage: 7,
        seats: 8,
        priority: 9
    },
    defaultStage: 1,
    goals: {
        duplicate_copy: 1,
        multiline_text: 2,
        premium_seat: 3
    }
});
export default utils;
